import { render } from "./ShouRuBoLiPage.vue?vue&type=template&id=29d18f85&scoped=true"
import script from "./ShouRuBoLiPage.vue?vue&type=script&lang=js"
export * from "./ShouRuBoLiPage.vue?vue&type=script&lang=js"

import "./ShouRuBoLiPage.vue?vue&type=style&index=0&id=29d18f85&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29d18f85"]])

export default __exports__